import IPaymentMethod from "../models/paymentMethodModel";
import payments from "../repositories/payments";

export const getPaymentMethods = async (
  callback: (data: IPaymentMethod[], err: any) => void
) => {
  try {
    const rs = await payments.getPaymentMethods();
    callback(rs.data, null);
  } catch (error) {
    let empty: any = null;
    callback(empty, error);
  }
};

export default {
  signAndEncryptPayment: async (
    params: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await payments.signAndEncryptPaymentRequest(params);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  payooPayment: async (
    params: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await payments.payooPayment(params);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  payooPaymentRetry: async (
    params: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await payments.payooPaymentRetry(params);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  payooVerifyTransaction: async (
    data: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await payments.payooVerifyTransaction(data);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
